import React, { useEffect, useState } from "react";
import { fetchJson } from "../../lib/Fetching";
import classNames from "classnames";
import Link from "../Link";
import _ from "underscore";
import Tooltip from "../common/Tooltip";
// import Input from "../Input";
// import Button from "../Button";
// import ContainerAliquotStatus from "../ContainerAliquotStatus";

export default function ContainerAliquotStatus({
  containerId,
  highlightAliquotId,
  handleAliquotClick,
}) {
  const [message, setMessage] = useState("");
  const [aliquots, setAliquots] = useState([]);
  const [lastRefreshedAt, setLastRefreshedAt] = useState(null);

  useEffect(
    () => {
      fetchAliquots();
    },
    [containerId]
  );

  const information = {
    sampleCount: _.uniq(aliquots.map((a) => a.sample_id)).length,
    aliquotCount: aliquots.length,
    completeAliquots: aliquots.filter((a) => a.all_results_present).length,
  };

  const fetchAliquots = () => {
    setAliquots([]);

    if (!containerId || !containerId.trim()) return;

    fetchJson("/scheduling/aliquots.json", {
      search: containerId,
      include_result_status: true,
    }).then((json) => {
      if (json.error) {
        setMessage(json.error);
        setAliquots([]);
        return;
      }
      setLastRefreshedAt(new Date());
      setAliquots(json);
    });
  };

  const aliquotMissing =
    aliquots.length > 0 &&
    highlightAliquotId &&
    aliquots.filter((a) => a.id === highlightAliquotId).length == 0;

  return (
    <div className="aliquot-container">
      {aliquotMissing && (
        <div className="alert alert-danger">
          DANGER: The current aliquot is not within this container!
        </div>
      )}
      {message && <div className="alert alert-danger">{message}</div>}
      <p>
        <Link onClick={fetchAliquots}>
          <i className="fa fa-refresh" />
          &nbsp; Refresh
        </Link>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        <a target="_blank" href={"/tracking/items/" + containerId}>
          Open in Item Tracking System
        </a>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        {lastRefreshedAt && <span>Last refreshed at {lastRefreshedAt.toTimeString()}</span>}
      </p>

      <p className="aliquot-information">
        {information.aliquotCount} ALIQUOTS &nbsp;&nbsp;|&nbsp;&nbsp;
        {information.completeAliquots} COMPLETED ALIQUOTS &nbsp;&nbsp;
        <Tooltip id={"container-aliquot-completed-info"}>
          A completed aliquot means all the results linked to that aliquot have been entered.
        </Tooltip>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        {information.sampleCount} UNIQUE SAMPLE REFERENCES
      </p>

      {aliquots.length > 0 && (
        <div style={{ display: "flex", marginBottom: 0, flexWrap: "wrap" }}>
          {aliquots.map((aliquot, index) => (
            <div
              key={aliquot.id}
              onClick={() => handleAliquotClick(aliquot)}
              className={classNames(
                {
                  all_results_present: aliquot.all_results_present,
                  tech_review_present:
                    aliquot.tech_review_count && aliquot.tech_review_count > 0,
                  retain: aliquot.retained,
                  highlight: aliquot.id == highlightAliquotId,
                  same_sample_next:
                    aliquots[index + 1] && aliquots[index + 1].sample_id === aliquot.sample_id,
                  same_sample_before:
                    aliquots[index - 1] && aliquots[index - 1].sample_id === aliquot.sample_id,
                },
                "aliquot-plate"
              )}
              style={{ position: "relative" }}
            >
              <p>
                <b>{aliquot.identifier}</b>
              </p>
              {aliquot.label_information &&
                aliquot.label_information.map((info, i) => (
                  <p key={i} className="info">
                    {info}
                  </p>
                ))}
              {aliquot.sample_test_count > 0 && (
                <p>
                  {aliquot.result_count} / {aliquot.sample_test_count}
                  &nbsp;&nbsp;
                  {aliquot.result_count == aliquot.sample_test_count && (
                    <i className="fa fa-check" />
                  )}
                </p>
              )}
              {aliquot.sample_test_count == 0 && <p>No tests</p>}
              {aliquot.tech_review_count && aliquot.tech_review_count > 0 ? (
                <p>
                  <b>Tech REVIEW - Keep plate!!</b>
                </p>
              ) : aliquot.retained ? (
                <p>
                  <b>Retain plate!!</b>
                </p>
              ) : (
                ""
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
